// extracted by mini-css-extract-plugin
module.exports = {"root":"TenantAutoEdit_root__1rnI2","title":"TenantAutoEdit_title__395SG","list":"TenantAutoEdit_list__1gjSH"};